// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-btn-group {
  display: inline-flex;
  flex-wrap: nowrap;
  max-width: 100%;
  min-width: 0;
  overflow-y: hidden;
  overflow-x: auto;
  vertical-align: middle;
}
:where(.vuetify-styles) .v-btn-group {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-btn-group--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-btn-group {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-btn-group {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-btn-group {
  background: transparent;
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-btn-group--density-default.v-btn-group {
  height: 48px;
}

:where(.vuetify-styles) .v-btn-group--density-comfortable.v-btn-group {
  height: 40px;
}

:where(.vuetify-styles) .v-btn-group--density-compact.v-btn-group {
  height: 36px;
}

:where(.vuetify-styles) .v-btn-group .v-btn {
  border-radius: 0;
  border-color: inherit;
}
:where(.vuetify-styles) .v-btn-group--tile {
  border-radius: 0;
}
:where(.vuetify-styles) .v-btn-group--horizontal .v-btn:not(:last-child) {
  border-inline-end: none;
}
:where(.vuetify-styles) .v-btn-group--horizontal .v-btn:not(:first-child) {
  border-inline-start: none;
}
:where(.vuetify-styles) .v-btn-group--horizontal .v-btn:first-child {
  border-start-start-radius: inherit;
  border-end-start-radius: inherit;
}
:where(.vuetify-styles) .v-btn-group--horizontal .v-btn:last-child {
  border-start-end-radius: inherit;
  border-end-end-radius: inherit;
}
:where(.vuetify-styles) .v-btn-group--horizontal.v-btn-group--divided .v-btn:not(:last-child) {
  border-inline-end-width: thin;
  border-inline-end-style: solid;
  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity));
}
:where(.vuetify-styles) .v-btn-group--vertical {
  flex-direction: column;
  height: auto !important;
}
:where(.vuetify-styles) .v-btn-group--vertical .v-btn:not(:last-child) {
  border-block-end: none;
}
:where(.vuetify-styles) .v-btn-group--vertical .v-btn:not(:first-child) {
  border-block-start: none;
}
:where(.vuetify-styles) .v-btn-group--vertical .v-btn:first-child {
  border-start-start-radius: inherit;
  border-start-end-radius: inherit;
}
:where(.vuetify-styles) .v-btn-group--vertical .v-btn:last-child {
  border-end-start-radius: inherit;
  border-end-end-radius: inherit;
}
:where(.vuetify-styles) .v-btn-group--vertical.v-btn-group--divided .v-btn:not(:last-child) {
  border-block-end-width: thin;
  border-block-end-style: solid;
  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity));
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VBtnGroup/VBtnGroup.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sOAAsO;AACxO;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,sEAAsE;AACxE;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,6EAA6E;AAC/E;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,4EAA4E;AAC9E","sourcesContent":[".v-btn-group {\n  display: inline-flex;\n  flex-wrap: nowrap;\n  max-width: 100%;\n  min-width: 0;\n  overflow-y: hidden;\n  overflow-x: auto;\n  vertical-align: middle;\n}\n.v-btn-group {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-btn-group--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-btn-group {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-btn-group {\n  border-radius: 4px;\n}\n.v-btn-group {\n  background: transparent;\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-btn-group--density-default.v-btn-group {\n  height: 48px;\n}\n\n.v-btn-group--density-comfortable.v-btn-group {\n  height: 40px;\n}\n\n.v-btn-group--density-compact.v-btn-group {\n  height: 36px;\n}\n\n.v-btn-group .v-btn {\n  border-radius: 0;\n  border-color: inherit;\n}\n.v-btn-group--tile {\n  border-radius: 0;\n}\n.v-btn-group--horizontal .v-btn:not(:last-child) {\n  border-inline-end: none;\n}\n.v-btn-group--horizontal .v-btn:not(:first-child) {\n  border-inline-start: none;\n}\n.v-btn-group--horizontal .v-btn:first-child {\n  border-start-start-radius: inherit;\n  border-end-start-radius: inherit;\n}\n.v-btn-group--horizontal .v-btn:last-child {\n  border-start-end-radius: inherit;\n  border-end-end-radius: inherit;\n}\n.v-btn-group--horizontal.v-btn-group--divided .v-btn:not(:last-child) {\n  border-inline-end-width: thin;\n  border-inline-end-style: solid;\n  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity));\n}\n.v-btn-group--vertical {\n  flex-direction: column;\n  height: auto !important;\n}\n.v-btn-group--vertical .v-btn:not(:last-child) {\n  border-block-end: none;\n}\n.v-btn-group--vertical .v-btn:not(:first-child) {\n  border-block-start: none;\n}\n.v-btn-group--vertical .v-btn:first-child {\n  border-start-start-radius: inherit;\n  border-start-end-radius: inherit;\n}\n.v-btn-group--vertical .v-btn:last-child {\n  border-end-start-radius: inherit;\n  border-end-end-radius: inherit;\n}\n.v-btn-group--vertical.v-btn-group--divided .v-btn:not(:last-child) {\n  border-block-end-width: thin;\n  border-block-end-style: solid;\n  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity));\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
